module.exports = ".training-tree {\n    float: left;\n    width: 250px;\n    height: 100vh;\n    border-right: 1px solid #cccdc8;\n}\n.training-tree:last-child {\n    margin-bottom: 10px;\n}\n.trainingQueryFilter {\n    font-size: 12px;\n    height: 20px;\n    width: 235px;\n    border: 1px hidden;\n    color: #4b4a4a;\n    padding: 1ch;\n}\ninput.trainingQueryFilter:focus {\n    outline-width: 0;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/view/training-tree/training-tree.component.css
// module id = ./src/app/view/training-tree/training-tree.component.css
// module chunks = main